module.exports = __webpack_public_path__ + "img/brush-01.d66d7c7e.svg";